"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolveCompositionBeforeModal = exports.ResolvedCompositionContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const remotion_1 = require("remotion");
const colors_1 = require("../../helpers/colors");
const styles_1 = require("../Menu/styles");
const RunningCalculateMetadata_1 = require("../RunningCalculateMetadata");
const layout_1 = require("../layout");
const loaderContainer = {
    paddingTop: 40,
    paddingBottom: 40,
    paddingLeft: 100,
    paddingRight: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
};
const loaderLabel = {
    fontSize: 14,
    color: colors_1.LIGHT_TEXT,
    fontFamily: 'sans-serif',
    lineHeight: 1.5,
};
exports.ResolvedCompositionContext = react_1.default.createContext(null);
const ResolveCompositionBeforeModal = ({ compositionId, children }) => {
    const resolved = remotion_1.Internals.useResolvedVideoConfig(compositionId);
    const unresolvedContext = (0, react_1.useContext)(remotion_1.Internals.CompositionManager);
    const unresolved = unresolvedContext.compositions.find((c) => compositionId === c.id);
    (0, react_1.useEffect)(() => {
        const { current } = remotion_1.Internals.resolveCompositionsRef;
        if (!current) {
            throw new Error('No ref to trigger composition calc');
        }
        current.setCurrentRenderModalComposition(compositionId);
        return () => {
            current.setCurrentRenderModalComposition(null);
        };
    }, [compositionId]);
    if (!unresolved) {
        throw new Error('Composition not found: ' + compositionId);
    }
    const value = (0, react_1.useMemo)(() => {
        return {
            resolved: resolved,
            unresolved,
        };
    }, [resolved, unresolved]);
    if (!resolved || resolved.type === 'loading') {
        return (0, jsx_runtime_1.jsx)(RunningCalculateMetadata_1.RunningCalculateMetadata, {});
    }
    if (resolved.type === 'error') {
        return ((0, jsx_runtime_1.jsxs)("div", { style: loaderContainer, children: [(0, jsx_runtime_1.jsx)(layout_1.Spacing, { y: 2 }), (0, jsx_runtime_1.jsxs)("div", { style: loaderLabel, children: ["Running ", (0, jsx_runtime_1.jsx)("code", { style: styles_1.inlineCodeSnippet, children: "calculateMetadata()" }), ' ', "yielded an error:"] }), (0, jsx_runtime_1.jsx)(layout_1.Spacing, { y: 1 }), (0, jsx_runtime_1.jsx)("div", { style: loaderLabel, children: resolved.error.message || 'Unknown error' })] }));
    }
    return ((0, jsx_runtime_1.jsx)(exports.ResolvedCompositionContext.Provider, { value: value, children: children }));
};
exports.ResolveCompositionBeforeModal = ResolveCompositionBeforeModal;
